<template>
  <section class="sec-post-image" v-if="!!video">
    <div :class="container">
      <div class="td-salon__image td-salon__image--full">
        <iframe :src="video" frameborder="0" allow="encrypted-media" allowfullscreen class="iframe-video"></iframe>
      </div>
      <div v-if="!!note" class="sec-content__image-text" :class="{'container-middle': container === 'no-container'}"> <!-- container-small -->
        <p>{{note}}</p>
      </div>
    </div>
  </section>
</template>

<script>
import mixin from '@/mixins/sections/styleSettings'
export default {
  mixins: [mixin],
  computed: {
    // hasData to be in mixin
    video() {
      return this.hasData.video
    },
    note() {
      return this.hasData.note
    },
  }
}
</script>
